import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'features',
  label: 'Features / Service Highlights',
  description: 'A grid of service highlight cards with icon, title, and subtitle.',
  supportedPages: ['home', 'shop', 'category'],
  variants: [{ id: 'v1', label: 'V1 (2×2 Grid)' }],
  commonFields: [
    { key: 'title', label: 'Section Title', type: 'string' },
    {
      key: 'items',
      label: 'Feature Items',
      type: 'array',
      itemSchema: [
        {
          key: 'icon',
          label: 'Icon',
          type: 'select',
          options: [
            { label: 'Truck (Delivery)', value: 'truck' },
            { label: 'Zap (Fast)', value: 'zap' },
            { label: 'Shield (Secure)', value: 'shield' },
            { label: 'Headphones (Support)', value: 'headphones' },
            { label: 'Package (Packaging)', value: 'package' },
            { label: 'RefreshCw (Returns)', value: 'refresh-cw' },
            { label: 'Star (Quality)', value: 'star' },
            { label: 'Award (Certified)', value: 'award' },
          ],
          default: 'truck',
        },
        { key: 'title', label: 'Title', type: 'string' },
        { key: 'subtitle', label: 'Subtitle', type: 'string' },
      ],
      default: [
        { icon: 'truck', title: 'হোম ডেলিভারি', subtitle: 'সারাদেশে ডেলিভারি' },
        { icon: 'zap', title: 'ফাস্ট ডেলিভারি', subtitle: 'দ্রুত ডেলিভারি সার্ভিস' },
        { icon: 'shield', title: 'সিকিউর পেমেন্ট', subtitle: 'নিরাপদ পেমেন্ট' },
        { icon: 'headphones', title: '২৪/৭ সাপোর্ট', subtitle: 'যেকোনো সময় সাহায্য' },
      ],
    },
  ],
}
